import { render, staticRenderFns } from "./index.html?vue&type=template&id=18731d73&"
import script from "./ImportQuestion.vue?vue&type=script&lang=js&"
export * from "./ImportQuestion.vue?vue&type=script&lang=js&"
import style0 from "./ImportQuestion.vue?vue&type=style&index=0&id=18731d73&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports